import React from 'react'

// eslint-disable-next-line
export default ({children, clsName='defaultCover'}) =>
	<header className={clsName}>
		{children}
	</header>	